import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import './PullQuote.scss';

export type PullQuoteColorOptions = `blue` | `gray` | `yellow`;
export type PullQuoteStyleOptions = `fill` | `border` | `full`;
export interface PullQuoteInputs {
    color: PullQuoteColorOptions;
    style: PullQuoteStyleOptions;
    author: string;
    text: string;
    image?: any;
    imageAlt?: string;
}

export const PullQuote = ({ inputs }: { inputs: PullQuoteInputs }) => {
    return (
        <blockquote
            role="doc-pullquote"
            className={`paragraph__pull_quote ${inputs.style} ${inputs.color} ${
                inputs.style !== `full` ? `kite-container` : ``
            }`}
        >
            {inputs.style === `full` && (
                <>
                    <div className="kite-container">
                        <div className={`typestack-title-3 ${inputs.color}`}>
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: inputs.text,
                                }}
                            ></p>
                        </div>
                        <cite
                            className={`author typestack-body-1 ${inputs.color}`}
                        >
                            <span>{inputs.author}</span>
                        </cite>
                    </div>
                    {inputs.image && (
                        <GatsbyImage
                            image={getImage(inputs.image)}
                            alt={inputs.imageAlt}
                        />
                    )}
                </>
            )}

            {inputs.style !== `full` && (
                <>
                    <div
                        className="typestack-title-3"
                        dangerouslySetInnerHTML={{ __html: inputs.text }}
                    ></div>
                    <cite className="author typestack-body-1">
                        {inputs.author}
                    </cite>
                </>
            )}
        </blockquote>
    );
};
